import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_VIEW_LOGS: {
        url: "logbook-view-logs",
        method: "get",
    },
};


export const useViewLogs = (communityName = "Alle") =>
    useApiFetcherSWR({
        ...API_ENDPOINT.GET_VIEW_LOGS,
        url:
            communityName && communityName !== "Alle besturen"
                ? `logbook-view-logs?search=${communityName}`
                : "logbook-view-logs",
    });



    